export default {
    route: {
        hidden: true,
        meta: {
            title: '注册',
            auth: "public"
        }
    }
}
